// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .underline {
    border-bottom: 2px solid ${(props) => props.theme.colorPalette.blue[200]};
    width: 150px;
    margin: 16px auto ${(props) => props.theme.spacing.ELEM_SPACING.XXL} auto;
  }
  .back-bag {
    text-decoration: underline;
    cursor: pointer;
  }
  .back-bag-cont {
    justify-content: center;
    display: flex;
  }
`;

export default styles;
